"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FULL = 'full';
exports.SPLIT = 'split';
exports.SPLIT_2 = 'split-2';
exports.SPLIT_3 = 'split-3';
exports.SPLIT_4 = 'split-4';
exports.SLIDE = 'slide';
exports.SLIDE_2 = 'slide-2';
exports.SLIDE_3 = 'slide-3';
exports.SLIDE_4 = 'slide-4';
exports.displayTypes = [
    exports.FULL,
    exports.SPLIT_2,
    exports.SPLIT_4,
    exports.SLIDE_2,
    exports.SLIDE_3,
    exports.SLIDE_4
];
exports.displayTypesWithText = [
    {
        id: exports.FULL,
        text: 'Full screen',
        meta: { slotNo: 1 }
    },
    {
        id: exports.SPLIT_2,
        text: 'Split 2',
        meta: { slotNo: 1, bannerNo: 2 }
    },
    {
        id: exports.SPLIT_4,
        text: 'Split 4',
        meta: { slotNo: 1, bannerNo: 4 }
    },
    {
        id: exports.SLIDE_2,
        text: 'Slide 2',
        meta: { slotNo: 2 }
    },
    { id: exports.SLIDE_3, text: 'Slide 3', meta: { slotNo: 3 } },
    { id: exports.SLIDE_4, text: 'Slide 4', meta: { slotNo: 4 } }
];
exports.getDisplayTypeCategory = (type) => {
    if (!type || exports.displayTypes.indexOf(type) < 0)
        return exports.FULL;
    return type.split('-').shift();
};
exports.getDisplayTypeSlotNo = (type) => {
    if (!type || exports.displayTypes.indexOf(type) < 0)
        return 1;
    const displayType = exports.displayTypesWithText.find(item => item.id === type);
    return displayType.meta.slotNo;
};
exports.getDisplayTypeBannerNo = (type) => {
    if (!type || exports.displayTypes.indexOf(type) < 0)
        return 1;
    const displayType = exports.displayTypesWithText.find(item => item.id === type);
    return displayType.meta.bannerNo || 1;
};
//# sourceMappingURL=campaignDisplayType.js.map